import { render, staticRenderFns } from "./AiAuditTabCard.vue?vue&type=template&id=f6e806c8"
import script from "./AiAuditTabCard.vue?vue&type=script&lang=js"
export * from "./AiAuditTabCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports